import script from "./UserToolbar.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserToolbar.vue?vue&type=script&setup=true&lang=ts"

import "./UserToolbar.vue?vue&type=style&index=0&id=5a68f3b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a68f3b8"]])

export default __exports__